export const ENABLE_FLIGHTS_CFAR = true;
export const ENABLE_PAYMENT_METHODS_SUBTITLE = false;
export const ENABLE_POLL_INTERACTIVE = false;
export const ENABLE_FLIGHT_FX_DISCLAIMER = false;
